import { createSelector } from "reselect";
import { _ } from "lodash";

export const selectJobPack = ({ JobPackEdit_reducer }) => {
    if (
        typeof JobPackEdit_reducer.job_packs === "undefined" ||
        JobPackEdit_reducer.job_packs === null ||
        JobPackEdit_reducer.job_packs === false
    )
        return false;
    return JobPackEdit_reducer.job_packs.profile;
};

export const selectReportTitles = ({ JobPackEdit_reducer }) => {
    return JobPackEdit_reducer.reportTitles;
};
export const selectUsers = ({ JobPackEdit_reducer }) => {
    return JobPackEdit_reducer.users;
};
export const selectUploadedFiles = ({ JobPackEdit_reducer }) => {
    return JobPackEdit_reducer.uploadedFiles;
};

export const selectTemplateList = ({ JobPackEdit_reducer }) => {
    return JobPackEdit_reducer.templateList;
};

export const selectProfileList = createSelector(
    [selectTemplateList],
    templates => {
        if (templates === false || typeof templates === "undefined") {
            return [];
        }

        let templateDetailsList = [];
        _.forOwn(templates, e => {
            _.forOwn(e, j => {
                templateDetailsList.push(j);
            });
        });

        return templateDetailsList;
    }
);

export const selectAllUsers = createSelector(
    [selectUsers],
    allUsers => {
        if (allUsers === false) {
            return [];
        } else {
            const userNames = Object.keys(allUsers).map(e => {
                const fname = allUsers[e].profile.first_name;
                const lname = allUsers[e].profile.last_name;
                return { name: `${fname} ${lname}` };
            });
            return userNames;
        }
    }
);
